// @flow

import googleAnalytics from '@analytics/google-analytics'

const GOOGLE_ANALYTICS_SHORT_NAME: string = 'GA'

export const ANALYTICS_PLUGINS = {
  [GOOGLE_ANALYTICS_SHORT_NAME]: (config: Object) =>
    googleAnalytics({
      ...config,
      tasks: {
        ...config.tasks,
        checkProtocolTask: null,
        checkStorageTask: null,
      },
      customDimensions: {
        deviceBrand: 'dimension1',
        deviceModel: 'dimension2',
        deviceOS: 'dimension3',
        deviceOSVersion: 'dimension4',
      },
    }),
}

export const ANALYTICS_EVENT = {
  PROMO_CLICK: 'promo_click',
  PLAYBACK_HEARTBEAT: 'playback_heartbeat',
  P2P_SESSION: 'p2p_session',
}
